/* ═════════════════════════════════════════════════════════════════════════════
   SRC/COMPONENTS/PDFEXPORTMODAL/PDFFILTERS.JS — recorte ativo no relatório PDF
   ─────────────────────────────────────────────────────────────────────────────
   O PDF sai com os dados do recorte da tela (cidade, segmento NPS, vínculo),
   mas a capa e o rodapé não diziam isso — quem recebia o arquivo lia os
   números de uma cidade como se fossem da operadora inteira. Função pura,
   sem React, para ser testada direto.

   USADO POR
   components/dashboard/Dashboard121Insights.jsx (capa e rodapé do PDF).
   ═══════════════════════════════════════════════════════════════════════════ */

// Mesmo rótulo do filtro de vínculo na tela (VINCULO_OPCOES no Dashboard).
const VINCULO_LABEL = {
  Local: "Próprios da Unimed",
  Intercâmbio: "Intercâmbio",
};

/**
 * Descreve os filtros ativos além do período, ou "" quando é o geral.
 * Ex.: "Cidade: Porto Alegre · Segmento NPS: Promotores".
 */
export function describeActiveFilters(filters = {}) {
  const partes = [];
  if (filters.city && filters.city !== "todas") {
    partes.push(`Cidade: ${filters.city}`);
  }
  if (filters.npsSegment) {
    partes.push(`Segmento NPS: ${filters.npsSegment}`);
  }
  if (filters.clientType) {
    partes.push(
      `Vínculo: ${VINCULO_LABEL[filters.clientType] ?? filters.clientType}`,
    );
  }
  return partes.join(" · ");
}
